<template>
	<v-hover class="fill-height" v-slot:default="{ hover }">
		<v-container class="ma-0 pa-0 d-flex align-start">
			<v-container v-if="lotesAlocadosCreche.length > 0" class="pa-2 ma-0">
				<v-row v-for="itemLote in lotesAlocadosCreche" class="pa-0 ma-0"
				       :key="`${itemLote.idPlanejamentoAlojamentoAlocado}-LoteAlocado`">
					<!-- Cards Lotes Alocados -->
					<lotes-alocados-card :itemLoteAlocado="itemLote" :itemCrechario="crechario" :nrDia="dataAlojamento.dia"
					                     :listaPeriodoEntregaAlojamento="listaPeriodoEntregaAlojamento" />
				</v-row>
			</v-container>
			<v-container v-else class="ma-0 pa-2">
				<v-row class="pa-0 ma-0">
					<v-card
							flat
							height="290px"
							width="100%"
							class="card-lotes-alojados"
					>
						<v-layout row justify-center fill-height ma-0>
							<v-flex lg11 class="spacing-nenhum-lote-alocado">
								<span class="label-adicionar-lotes">Nenhum Lote Selecionado</span>
							</v-flex>
						</v-layout>
					</v-card>
				</v-row>
			</v-container>

			<!-- Overlay copiar lote em cache -->
			<v-fade-transition hide-on-leave>
				<v-overlay absolute :value="hover && cacheLoteAlocado" z-index="3">
					<v-row justify="center" align="center" class="ma-2">
						{{ podeColar ? 'Colar Lote' : 'Esse lote já está alocado para este dia.' }}
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#2BC1B6" :disabled="!podeColar" small class="white--text"
								       @click="ActColarLoteAlocado({
										       cdCrecheSemLote: crechario.cdCrecheSemLote,
										       cdLoteProducaoCreche: crechario.cdLoteProducaoCreche,
										       stDiaAlocado: `qtDia${dataAlojamento.dia}`,
										       dtAlocado: dataAlojamento.data
								       })">
									<v-icon small>fas fa-paste</v-icon>
								</v-btn>
							</template>
							<span>Colar</span>
						</v-tooltip>
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#CACACA" small class="white--text"
								       @click="mtCancelaCopiarRecortarLoteAlocado()">
									<v-icon small>fas fa-times</v-icon>
								</v-btn>
							</template>
							<span>Cancelar colagem</span>
						</v-tooltip>
					</v-row>
				</v-overlay>
			</v-fade-transition>
		</v-container>
	</v-hover>
</template>

<script>
import LotesAlocadosCard from "./LotesAlocadosCard";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
	name: "AlojamentoCardLotes",
	components: {LotesAlocadosCard},
	data: () => ({
		loading: false,
	}),
	computed: {
		...mapState("planejamentoAlojamento", ["listaLotesAlocados", "cacheLoteAlocado"]),
		lotesAlocadosCreche() {
			if (!this.listaLotesAlocados || this.listaLotesAlocados.length === 0) return []
			return this.listaLotesAlocados.filter(lote => (
					lote.cdCrecheSemLote === this.crechario.cdCrecheSemLote &&
					lote.cdLoteProducaoCreche === this.crechario.cdLoteProducaoCreche &&
					lote.stDiaAlocado === `qtDia${this.dataAlojamento.dia}`
			))
		},
		podeColar() {
			if (!this.cacheLoteAlocado) return false

			const idx = this.lotesAlocadosCreche.findIndex(lote => {
				return this.cacheLoteAlocado.cdPlanejamentoAlojamentoLoteDestino === lote.cdPlanejamentoAlojamentoLoteDestino &&
						lote.stDiaAlocado === `qtDia${this.dataAlojamento.dia}`
			})
			return idx === -1
		},
	},
	methods: {
		...mapActions("planejamentoAlojamento", ["ActColarLoteAlocado"]),
		...mapMutations("planejamentoAlojamento", ["mtCancelaCopiarRecortarLoteAlocado"]),
	},
	props: {
		crechario: {
			required: true,
			type: Object,
		},
		dataAlojamento: {
			required: true,
			type: Object,
		},
		listaPeriodoEntregaAlojamento: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style scoped lang="scss">

.card-lotes-alojados {
  background-color: #e5e8e7 !important;
  border: dashed 2px #bdccca !important;
  border-radius: 8px !important;
  opacity: 1;
}

.spacing-nenhum-lote-alocado {
  height: fit-content;
  align-self: center;
  text-align: center;
}

.label-adicionar-lotes {
  color: #37565c !important;
  font: 20px Roboto;
}

</style>
